import React from 'react';
import PropTypes from 'prop-types';

const Metric = ({ label, value }) => (
    <div className="metrics">
        <div className="metrics-label">
            {label}
        </div>
        <div className="metrics-value">
            {value ? (
                <>{value}</>
            ) : (
                <span className="icon dash"/>
            )}
        </div>
    </div>
);

Metric.propTypes = {
    label: PropTypes.string,
};
export default Metric;
